export { default } from './parseTemplates'
export * from './parseTemplates'
